import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from 'oidc-react';
import Environment from './Environment';
import { worker } from './mocks/browser';

if (process.env.NODE_ENV === 'local') {
  worker.start();
}

// Expose Environment config globally for silent-refresh.html
window.AppEnvironment = {
  AUTH_URL: Environment.AUTH_URL(),
  CLIENT_ID: Environment.CLIENT_ID(),
  APP_URL: Environment.APP_URL(),
  REDIRECT_URL: Environment.REDIRECT_URL()
};

// Capture cocode/year/periodType/viewMode from the URL up front, before the
// OIDC provider mounts. onBeforeSignIn only fires when the library actually
// redirects to the identity provider; if auth is already established (silent
// renew, cached tokens) it never runs and the query params get lost.
function captureQueryParamsToSession() {
  const queryParams = new URLSearchParams(window.location.search);
  const cocode = queryParams.get('cocode');
  const year = queryParams.get('year');
  if (cocode) {
    window.sessionStorage.setItem('cocode', cocode);
  }
  if (year) {
    window.sessionStorage.setItem('year', year);
  }
  const periodType = queryParams.get('periodType');
  const viewMode = queryParams.get('viewMode');
  if (periodType) {
    window.sessionStorage.setItem('periodType', periodType);
  } else if (cocode || year) {
    // Only clear stale period state when the URL carries a fresh cocode/year.
    // A bare reload (no query params) should keep whatever the user last had.
    window.sessionStorage.removeItem('periodType');
  }
  if (viewMode) {
    window.sessionStorage.setItem('viewMode', viewMode);
  } else if (cocode || year) {
    window.sessionStorage.removeItem('viewMode');
  }
}
captureQueryParamsToSession();

const oidcConfig = {
  onBeforeSignIn: () => {
    // Also refresh from URL here in case the flow reaches sign-in with newer
    // params (e.g., user re-navigates during an in-flight redirect).
    captureQueryParamsToSession();
  },
  onSignIn: (user) => {
    window.location.hash = '';
    window.sessionStorage.setItem('bearerToken', `Bearer ${user?.access_token}`);
  },
  authority: Environment.AUTH_URL()+'/oauth2/default',
  clientId: Environment.CLIENT_ID(),
  redirectUri: Environment.REDIRECT_URL(),
  responseType: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  postLogoutRedirectUri: Environment.APP_URL(),
  silentRedirectUri:  Environment.APP_URL() + '/silent-refresh.html',
  metadata: {
    authorization_endpoint: Environment.AUTH_URL()+'/oauth2/default/v1/authorize',
    token_endpoint: Environment.AUTH_URL()+'/oauth2/default/v1/token',
    userinfo_endpoint: Environment.AUTH_URL()+'/oauth2/default/v1/userinfo',
    jwks_uri: Environment.AUTH_URL()+'/oauth2/default/v1/keys'
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider {...oidcConfig}>
    <App />
  </AuthProvider>
);
